var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.ready
    ? _c(
        "div",
        [
          _vm.groupableOptions.length
            ? _c(
                "q-card",
                { staticClass: "mdi-card q-ma-md" },
                [
                  _c(
                    "q-card-main",
                    [
                      _c(
                        "q-field",
                        {
                          attrs: {
                            label: "Grouped By",
                            orientation: "vertical"
                          }
                        },
                        [
                          _c("q-select", {
                            attrs: {
                              options: _vm.groupableOptions,
                              "hide-underline": ""
                            },
                            on: { input: _vm.fetchData },
                            model: {
                              value: _vm.groupedByField,
                              callback: function($$v) {
                                _vm.groupedByField = $$v
                              },
                              expression: "groupedByField"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._l(Object.keys(_vm.groupedModels), function(key) {
            return !_vm.loading
              ? _c(
                  "q-card",
                  { key: key, staticClass: "mdi-card q-ma-md" },
                  [
                    _c(
                      "q-card-main",
                      [
                        _c(
                          "q-collapsible",
                          {
                            staticClass: "uppercase",
                            attrs: {
                              icon: "view_list",
                              label: _vm
                                ._f("shvl")(
                                  _vm.groupedModels[key][0],
                                  _vm.keyTitlePath || key
                                )
                                .toString(),
                              sparse: ""
                            }
                          },
                          [
                            _c(
                              "div",
                              [
                                _c(
                                  "q-list",
                                  {
                                    attrs: {
                                      separator: "",
                                      "no-border": "",
                                      link: ""
                                    }
                                  },
                                  _vm._l(_vm.groupedModels[key], function(row) {
                                    return _c(
                                      "q-item",
                                      {
                                        key: row.id,
                                        attrs: {
                                          to: {
                                            path:
                                              _vm.baseRoute + "/edit/" + row.id
                                          }
                                        }
                                      },
                                      [
                                        _vm.imageField
                                          ? _c(
                                              "q-item-side",
                                              [
                                                _c("grid-cell-image", {
                                                  attrs: {
                                                    col: _vm.imageField,
                                                    resource: _vm.resource,
                                                    value:
                                                      row[_vm.imageField.field]
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _c("q-item-main", {
                                          attrs: {
                                            label: _vm
                                              ._f("shvl")(
                                                row,
                                                _vm.titleFieldPath
                                              )
                                              .toString()
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  }),
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e()
          })
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }